import { createSvgComponent } from "../../icon/createSvgComponent";
import AlarmClock from "@core/__generated__/icon/figma/alarm-clock.svg";
export default createSvgComponent(AlarmClock);